export const FRESHWIDGET_ID = 48000000113
